export default __webpack_public_path__ + "static/media/profile.8b349f98.png";